import {
  ChallengeShell,
  ChoiceGrid,
  useChoices,
  usePickHandler,
  type ChallengeProps,
} from "./shared";

/** Listen to the English word, pick the Vietnamese meaning. */
export function AudioToVietnamese({ word, distractors, onAnswer }: ChallengeProps) {
  const choices = useChoices(word, distractors);
  const { picked, handle, teachOverlay } = usePickHandler(word, onAnswer);

  return (
    <>
    <ChallengeShell
      tag="Listen"
      prompt="Listen and pick the meaning"
      speakerText={word.english}
      speakerAudioUrl={word.audioUrl}
    >
      <ChoiceGrid
        choices={choices}
        correctId={word.id}
        picked={picked}
        onPick={handle}
        render={(c) => (
          <>
            <span className="choice-vi">{c.vietnamese}</span>
            <span className="choice-en muted">{c.english}</span>
          </>
        )}
      />
    </ChallengeShell>
    {teachOverlay}
    </>
  );
}
